interface SparklingBirdIconProps {
  className?: string
}

export const SparklingBirdIcon: React.FC<SparklingBirdIconProps> = ({
  className = "",
}) => {
  return (
    <svg
      width="29"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2813_21379)">
        <path
          d="M16.002 7H16.012"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.40195 18.0008H12.002C14.1237 18.0008 16.1585 17.1579 17.6588 15.6577C19.1591 14.1574 20.002 12.1225 20.002 10.0008V7.0008C20.0042 6.14871 19.7343 5.31817 19.2315 4.63019C18.7288 3.94222 18.0195 3.43276 17.207 3.17606C16.3945 2.91936 15.5212 2.92884 14.7145 3.2031C13.9077 3.47736 13.2097 4.00208 12.722 4.7008L2.00195 20.0008"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.002 7L22.002 7.5L20.002 8"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.002 18V21"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.002 17.75V21"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.00195 18.0006C8.23507 18.0006 9.43823 17.6206 10.4477 16.9123C11.4571 16.2041 12.2239 15.2021 12.6435 14.0425C13.0632 12.883 13.1154 11.6224 12.793 10.4321C12.4707 9.24189 11.7894 8.17988 10.842 7.39062"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.17752 5.17602L4.24414 8.48528L3.31079 5.17599L0.00150001 4.24264L3.31076 3.30926L4.24414 0L5.17752 3.30926L8.48678 4.24264L5.17752 5.17602Z"
          fill="#FFF440"
        />
      </g>
      <defs>
        <clipPath id="clip0_2813_21379">
          <rect
            width="26"
            height="24"
            fill="white"
            transform="translate(0.00195312)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
